import * as React from 'react';
import {
    Typography
} from '@mui/material';
import { useTranslate } from 'react-admin';

const Home = () => {
    const translate = useTranslate();

    return (
        <>
            <Typography variant="h4" component="h4">
                Welcome to HR System
            </Typography>
            <div>
                This page gives you updates of the HR system.
            </div>
        </>
    );
};

export default Home;
